import BaseService from "./Base"
import {get} from "lodash"

class UserProfessionalExperienceService extends BaseService {
    getAll = async (params = {}) => {
        const response = await this.post("/v1/user-professional-experience/list", params)
        return get(response, "data", [])
    }

    delete = async (params = {}) => {
        const response = await this.post("/v1/user-professional-experience/delete", params)
        return get(response, "data", {})
    }

    create = async (params = {}) => {
        const response = await this.post("/v1/user-professional-experience/create", params)
        return get(response, "data.data", {})
    }

    update = async (id, data, params = {}) => {
        data.userEducationalBackgroundId = id
        const response = await this.post("/v1/user-professional-experience/edit", data, params)
        return get(response, "data", {})
    }
}
export default UserProfessionalExperienceService
